import { z } from 'zod';

// Queue name constant shared between api and worker packages.
export const RESERVATIONS_TTL_SWEEP_QUEUE_NAME = 'reservations-ttl-sweep';

export const ReservationStatusSchema = z.enum([
  'SOFT_RESERVATION',
  'HARD_RESERVATION',
  'SOLD',
  'OPTION',
]);
export type ReservationStatus = z.infer<typeof ReservationStatusSchema>;

export const UnitBaseStatusSchema = z.enum(['FREE', 'ASK_AVAILABILITY']);
export type UnitBaseStatus = z.infer<typeof UnitBaseStatusSchema>;

export const QueueEntrySubtypeSchema = z.enum(['SOFT', 'HARD']);
export type QueueEntrySubtype = z.infer<typeof QueueEntrySubtypeSchema>;

export const ReservationSourceSchema = z.enum([
  'reservation_action',
  'manual_admin',
  'xlsx_import',
  'email_reply',
  'provider_override',
  'ttl_expiry',
  'auto_promotion',
  'auto_extension',
  'offer_version_locked',
]);
export type ReservationSource = z.infer<typeof ReservationSourceSchema>;
